import LabServiceModel from "@/models/LabServiceModel";
import LaboratoryModel from "@/models/lab/LaboratoryModel";
import InstrumentModel from "@/models/lab/InstrumentModel";

export default class InstrumentInstanceModel extends LabServiceModel {
  modelName() {
    return "instrument-instance";
  }
  icon() {
    return "microscope";
  }
  defaults() {
    return {
      id: null,
      instrument_id: null,
      instrument: null,
      laboratory_id: null,
      laboratory: null,
      name: null,
      description: null,
      primary: null,
      backup: null,
      created_at: null,
      updated_at: null,
      deleted_at: null,
      capacity: null,
      daily_capacity: null,
      equipment_number: null,
      identifier: null,
      location: null,
      model_number: null,
      multi_result: null,
      runtime: null,
      runtime_display: null,
      serial_number: null
    };
  }
  mutations() {
    return {
      id: val => this.nullStringMutator(val),
      instrument_id: val => this.nullStringMutator(val),
      laboratory_id: val => this.nullStringMutator(val),
      name: val => this.nullStringMutator(val),
      description: val => this.nullStringMutator(val),
      capacity: val => this.nullStringMutator(val),
      daily_capacity: val => this.nullStringMutator(val),
      equipment_number: val => this.nullStringMutator(val),
      identifier: val => this.nullStringMutator(val),
      location: val => this.nullStringMutator(val),
      model_number: val => this.nullStringMutator(val),
      multi_result: val => this.nullStringMutator(val),
      runtime: val => this.nullStringMutator(val),
      runtime_display: val => this.nullStringMutator(val),
      serial_number: val => this.nullStringMutator(val),
      primary: Boolean,
      backup: Boolean,
      created_at: String,
      updated_at: String,
      deleted_at: String
    };
  }
  validation() {
    return {};
  }
  getInstrument() {
    return this.getRelatedModel(InstrumentModel, "instrument");
  }
  getLaboratory() {
    return this.getRelatedModel(LaboratoryModel, "laboratory");
  }
}
